// import _ from "lodash";

export class Service {

    constructor(axios, endpoint) {
        this.data = [];
        this.fieldPrimaryKey = '';
        this.fields = [];
        this.mostrarAcciones = true;
        this.hardDelete = false;
        this.perPage = 15;
        this.currentPage = 1;
        this.filter = null;
        this.filterOn = []
        this.loading = false;
        this.endpoint = endpoint;
        this.http = axios;
    }

    onFiltered(filteredItems) {
        this.totalRows = filteredItems.length;
        this.currentPage = 1;
    }

    getUrl(pathParam, queryParams) {

        let url = process.env.VUE_APP_API_URL + this.endpoint;
        if (pathParam != null) {
            url += Array.isArray(pathParam) ? pathParam.join('/') : pathParam;
        }

        if (queryParams) {
            const parameters = new URLSearchParams(queryParams);
            url += '?'
            url += parameters.toString();
        }

        return url.toString();
    }

    /*
    queryParams is Array
    * */
    getUrlQuery(pathParam, queryParams) {

        let url = process.env.VUE_APP_API_URL + this.endpoint;
        if (pathParam != null) {
            url += Array.isArray(pathParam) ? pathParam.join('/') : pathParam;
        }

        if (pathParam != null) {
            const params = queryParams.join('/');
            url += params
        }

        return url.toString();
    }

    getUrlBase(pathParam, queryParams) {

        let url = process.env.VUE_APP_API_BASE_URL + '/' + this.endpoint;
        if (pathParam) {
            url += Array.isArray(pathParam) ? pathParam.join('/') : pathParam;
        }
        if (queryParams) {
            const parameters = new URLSearchParams(queryParams);
            url += '?'
            url += parameters.toString();
        }

        return url.toString();
    }

    onError(error) {

        if (error.response != null && error.response.data != null) {
            if (error.response.data.msj != null)
                throw new Error(error.response.data.msj)
            else if (error.response.data.detail != null)
                throw new Error(error.response.data.detail)
            else {
                throw new Error("Ocurrio un error al consultar el servicio")
            }
        } else {
            console.error(error);
            throw new Error("Ocurrio un error al consultar el servicio")
        }
    }

    onData(response) {
        return response.data;
    }


    onStart() {
        this.loading = true;
    }

    onFinaly() {
        this.loading = false;
    }

    orderData(campo, order) {
        return this._.orderBy(this.data, [campo],[order])
    }
    orderAscData(campo) {
        return this.orderData(campo, 'asc')
    }
    orderDescData(campo) {
        return this.orderData(campo, 'desc')
    }

    listar(params, config) {
        this.onStart();
        return this.http.get(this.getUrl(['listar'], params), config)
            .then((response) => this.onData(response))
            .then(response => {
                this.data = response.data;
                return this.data;
            })
            .catch((e) => {
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })
    }

    encontrarUno(id, params, config) {
        this.onStart();
        return this.http.get(this.getUrl(['obtener', id], params), config)
            .then((response) => this.onData(response))
            .then((response) => this.onData(response))
            .catch(this.onError)
            .finally(() => {
                this.onFinaly();
            })
    }

    crear(object, params, config) {
        this.onStart();
        return this.http.post(this.getUrl(['guardar'], params), object, config)
            .then((response) => {
                this.toast.info("Datos guardados con exito")
                return this.onData(response)
            })
            .then((response) => this.onData(response))
            .catch(this.onError)
            .finally(() => {
                this.onFinaly();
            })
    }

    actualizar(object, params, config) {
        this.onStart();
        return this.http.put(this.getUrl(['actualizar', object[this.fieldPrimaryKey]]), object, config)
            .then((response) => this.onData(response))
            .catch(this.onError)
            .finally(() => {
                this.onFinaly();
            })
    }

    eliminar(object, params, config) {
        this.onStart();
        return this.http.delete(this.getUrl(['eliminar', object[this.fieldPrimaryKey]]), config)
            .then((response) => this.onData(response))
            .catch(() => {
                object.registroActivo = false; // si no se puede eliminar se manda un softdelete
                return this.actualizar(object)
                    .then((response) => this.onData(response))
                    .catch(this.onError)
            })
            .finally(() => {
                this.onFinaly();
            })
    }

}
